import React from "react";
import { useState, useEffect, useRef } from "react";
import Loader from "react-js-loader";
import { Link } from "react-router-dom";
import Select, { components } from "react-select";
import { useDispatch } from "react-redux";
import UserService from "../../services/UserService"; import AuthService from "../../services/AuthService";
import getNotification from "../../Redux/Action/action";
import axios from "axios";
import FooterPages from "../Footer/FooterPages";
import Chart from "react-apexcharts";
import Navbar3 from "../Navbars/Navbar3";
import SubNavbar from "../Navbars/SubNavbar";
import ModelPerformanceChart from "./ModelPerformanceChart";
import SingleBarChart4 from "../Simulator/SingleBarChart4";
import SingleBarChart5 from "../Simulator/SingleBarChart5";
import SingleBarChart6 from "../Simulator/SingleBarChart6";
import ExceptionVariables from "../JSON Files/ExceptionVariables.json"
import SingleBarChart1 from "../Simulator/SingleBarChart1";
import SingleBarChart2 from "../Simulator/SingleBarChart2";
import SingleBarChart3 from "../Simulator/SingleBarChart3";
import PieCharts from "../Simulator/PieCharts";
import SingleBarChart7 from "../Simulator/SingleBarChart7";
import SingleBarChart8 from "../Simulator/SingleBarChart8";
import maskedBrandOption from '../JSON Files/MaskedBrandOption.json'

const { REACT_APP_REDIRECT_URI } = process.env;
const { REACT_APP_UPLOAD_DATA } = process.env;
const { REACT_APP_UPLOAD_DATA2 } = process.env;
const XLSX = require("xlsx");
function ModelPerformance() {
  const [isprocessing, setisprocessing] = useState(false)
  const selectAllOption = { label: "Select All", value: "selectAll" };
  const [isValue, setisValue] = useState(false)
  const dispatch = useDispatch();
  const [tablescreen, settablescreen] = useState(false)
  const [loader, setloader] = useState(false);
  const [modelcallibrationoptions, setmodelcallibrationoptions] = useState([
    { label: "test", value: "test" }
  ]);
  const [exportcontributiondata, setexportcontributiondata] = useState([])
  const [torangeonplots, settorangeonplots] = useState("")
  const [fromrangeonplots, setfromrangeonplots] = useState("")
  const [selectedmarketdataset, setselectedmarketdataset] = useState([])
  const [startDate, setStartDate] = useState("");
  const [openCollapseIndex, setOpenCollapseIndex] = useState(null);
  const [endDate, setEndDate] = useState("");
  const [mapetable, setmapetable] = useState([]);
  const [checkedbox, setcheckedbox] = useState([])
  const [brandoptions, setbrandoptions] = useState([]);
  const [displaynames, setdisplaynames] = useState({});
  const [marketoptions, setmarketoptions] = useState([])
  const [market, setmarket] = useState([]);

  const [modifybtn, setmodifybtn] = useState(false)
  const [selectedzone, setselectedzone] = useState("National")
  const [selectedbrand, setselectedbrand] = useState("");
  const [selectedscenarioname, setselectedscenarioname] = useState("");
  const [selectedscenarioid, setselectedscenarioid] = useState("");
  const [selectedscenarionametimestamp, setselectedscenarionametimestamp] =
    useState("");
  const [selectedyear, setselectedyear] = useState("2021-22");
  const [resultscreen, setresultscreen] = useState(false);
  const [lastfymapedata, setlastfymapedata] = useState([])
  const [loader2, setloader2] = useState(false)
  const sectionRef = useRef(null);

  const [openindex, setopenindex] = useState([])
  useEffect(() => {

    handlevariablesfetchfybrand()
    //handlevariablesfetch();
  }, []);

  useEffect(() => {
    handlevariablesfetch()
    handlefetchmarket()
  }, [selectedbrand])

  const today1 = new Date();
  const currentYear = today1.getFullYear();
  const currentMonth = today1.getMonth();

  let unblockeddate;
  if (currentMonth >= 3) {
    unblockeddate = new Date(currentYear, currentMonth, 1);
  } else {
    const currentmonth15thdate = new Date(today1.getFullYear(), today1.getMonth(), 1);
    const isBefore15th = new Date() < currentmonth15thdate;
    unblockeddate = isBefore15th ? new Date(today1.getFullYear(), today1.getMonth() - 2, 1) : new Date(today1.getFullYear(), today1.getMonth() - 2, 1);
  }

  const MonthBeforeUnlockMonth = `${unblockeddate.getFullYear()}-${String(unblockeddate.getMonth() + 1).padStart(2, "0")}`;
  const MonthBeforeUnlockMonthreverse = MonthBeforeUnlockMonth.split("-").reverse().join("-");

  const handlevariablesfetchfybrand = async () => {
    if (UserService.isLoggedIn()) {
      try {
        const FormData = require("form-data");
        const sendData = new FormData();

        const config = {
          method: "get",
          url: `${REACT_APP_UPLOAD_DATA}/app/get_brand_fy`,
          headers: {
            Accept: "text/plain",
            "Content-Type": "application/json",
          },
          data: sendData,
        };
        const getResponse = await axios(config);

        if (getResponse.data !== "Invalid User!") {


          // setbrandoptions(
          // ExceptionVariables?.brandoptions?.map((it)=>{
          // return {label:it.brand,value:it.brand}
          //            }))

          // setmarketoptions(
          //   getResponse.data.markets
          // );
          setbrandoptions(
            getResponse.data.brands?.filter(it => !ExceptionVariables?.brandoptionshide2?.includes(it?.brand))?.sort((a, b) => a.brand.localeCompare(b.brand))?.map((it) => {
              return { value: it.brand, label: maskedBrandOption.maskedBrandOption[it.brand] };
            })
          );

        }
      } catch (err) {
        console.log("Server Error", err);
        if (err.response && err.response.status === 500) {
          dispatch(
            getNotification({
              message: "Server is Down! Please try again after sometime",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 400) {
          dispatch(
            getNotification({
              message: "Input is not in prescribed format",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 422) {
          dispatch(
            getNotification({
              message: "Input is not in prescribed format",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 404) {
          dispatch(
            getNotification({
              message: "Page not Found",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 401) {
          dispatch(
            getNotification({
              message: "Session expired! Please log in again",
              type: "default",
            })
          );
        } else {
          dispatch(
            getNotification({
              message: "Server is Down! Please try again after sometime",
              type: "default",
            })
          );
        }
      }
    } else {
      setTimeout(() => {
        UserService.doLogin({
          redirectUri: `${REACT_APP_REDIRECT_URI}/modelperformance`,
        });
      }, 1000);
    }
  };
  const handleCheckboxChange = (index, row) => {
    // If the clicked checkbox is the same as the currently selected one, uncheck it
    if (openindex[index] === true) {
      let arr = []
      setopenindex(arr)
    }
    else {
      let arr = []
      arr[index] = true;

      setopenindex(arr)
      handlemodelperformanceapicharts(row.market);
    }
    // Call the analysis function

  };

  const handlefetchmarket = async () => {
    if (UserService.isLoggedIn()) {
      try {
        const FormData = require("form-data");
        const sendData = new FormData();
        sendData.append("brand", selectedbrand)
        const config = {
          method: "post",
          url: selectedbrand === "ATTA" ? `${REACT_APP_UPLOAD_DATA}/app/atta_get_markets` : `${REACT_APP_UPLOAD_DATA}/app/get_markets`,
          headers: {
            Accept: "text/plain",
            "Content-Type": "application/json",
            // "req-header":UserService.getToken()
          },
          data: sendData,
        };
        const getResponse = await axios(config);
        // console.log(getResponse)
        if (getResponse.data !== "Invalid User!") {
          setmarketoptions(
            [
              { value: "selectAll", label: "Select All" }, // Add Select All option
              ...getResponse.data.markets?.map((it) => ({
                value: it.final_market,
                label: it.final_market,
              })),
            ]
          );

        }
      } catch (err) {
        console.log("Server Error", err);
        if (err.response && err.response.status === 500) {
          dispatch(
            getNotification({
              message: "Server is Down! Please try again after sometime",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 400) {
          dispatch(
            getNotification({
              message: "Input is not in prescribed format",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 422) {
          dispatch(
            getNotification({
              message: "Input is not in prescribed format",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 404) {
          dispatch(
            getNotification({
              message: "Page not Found",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 401) {
          dispatch(
            getNotification({
              message: "Session expired! Please log in again",
              type: "default",
            })
          );
        } else {
          dispatch(
            getNotification({
              message: "Server is Down! Please try again after sometime",
              type: "default",
            })
          );
        }
      }
    } else {
      setTimeout(() => {
        UserService.doLogin({
          redirectUri: `${REACT_APP_REDIRECT_URI}/modelperformance`,
        });
      }, 1000);
    }
  };

  const handlemodelperformanceapi = async () => {
    setloader(true)
    if (UserService.isLoggedIn()) {
      try {
        if (selectedbrand && selectedbrand !== "Select" && market !== "Select" && market
          //selectedscenarioname
        ) {
          try {
            setselectedmarketdataset([])
            setopenindex([])
            let config1 = {};
            const requestData1 = {
              brand: selectedbrand,
              market: market
            };
            const requestData2 = {

              "scenario_name": 'Base Scenario',
              "scenario_timestamp": '2024-12-12 18:20:35',
              "user_id": "admin",
              "market": market,
              "model_id": 0,
              "brand": selectedbrand
            }
            config1 = {
              method: "post",
              url: selectedbrand === "ATTA" ? `${REACT_APP_UPLOAD_DATA}/app/atta_model_performance` : `${REACT_APP_UPLOAD_DATA}/app/model_performance`,
              headers: {
                Accept: "text/plain",
                "Content-Type": "application/json",

              },
              data: requestData1,
            };

            const getResponse1 = await axios(config1);


            if (getResponse1.data.data) {

              setfromrangeonplots(
                getResponse1?.data?.data?.market_wise_mape[0]?.predicted_sales[
                  getResponse1?.data?.data?.market_wise_mape[0]?.predicted_sales.length - 1
                ]?.month_year
                  ?.split("-")?.map((part, index) => {
                    if (index === 0) return new Date().getFullYear() > part ? part : part - 1; // Reduce the year by 1
                    if (index === 1) return "04"; // Set the month to "04"
                    return part; // Keep the day as is
                  })
                  ?.reverse()

                  ?.join("-")

              );
              settorangeonplots(
                getResponse1?.data?.data?.market_wise_mape[0]?.predicted_sales[getResponse1?.data?.data?.market_wise_mape[0]?.predicted_sales.length - 1]?.month_year?.split("-")?.reverse()?.join("-"))
              let arr1 = getResponse1?.data?.data?.fy_mape_data?.sort((a, b) => {
                const marketCompare = a.market?.localeCompare(b.market);
                if (marketCompare !== 0) return marketCompare;

                return a.fy?.localeCompare(b.fy);
              });

              let arr = getResponse1?.data?.data?.market_wise_mape


              let i = 0;
              arr = arr.map(it => {

                if (arr1[i] && arr1[i + 1]) {
                  const updatedItem = {
                    ...it,
                    lastfy: arr1[i].fy,
                    lastmape: arr1[i].mape,
                    currentfy: arr1[i + 1].fy,
                    currentmape: arr1[i + 1].mape
                  };
                  i += 2;
                  return updatedItem;
                }
                return it;
              });
              setmapetable(arr)

              setresultscreen(true);
              setloader(false);

              setdisplaynames({
                ...displaynames,
                brand: selectedbrand,
                market: market,
                scenarioname: selectedscenarioname,

              })
            }
          } catch (err) {
            console.log("Server Error", err);
            if (displaynames) {

              // setselectedscenarioid(displaynames.id || modelcallibrationoptions[1].id)
            }
            if (err.response && err.response.status === 500) {
              dispatch(
                getNotification({
                  message: "Server is Down! Please try again after sometime",
                  type: "default",
                })
              );
            } else if (err.response && err.response.status === 400) {
              dispatch(
                getNotification({
                  message: "Input is not in prescribed format",
                  type: "default",
                })
              );
            } else if (err.response && err.response.status === 422) {
              dispatch(
                getNotification({
                  message: "Input is not in prescribed format",
                  type: "default",
                })
              );
            } else if (err.response && err.response.status === 404) {
              dispatch(
                getNotification({
                  message: "Page not Found",
                  type: "default",
                })
              );
            } else if (err.response && err.response.status === 401) {
              dispatch(
                getNotification({
                  message: "Session expired! Please log in again",
                  type: "default",
                })
              ); setTimeout(UserService.doLogin(), 1000)
            } else {
              dispatch(
                getNotification({
                  message: "Server is Down! Please try again after sometime",
                  type: "default",
                })
              );
            }
          }
        }
        else {
          dispatch(
            getNotification({
              message: "Please fill all entries",
              type: "danger",
            })
          );
        }
      }
      catch (err) {
        console.log("Server Error", err);
        if (err.response && err.response.status === 500) {
          dispatch(
            getNotification({
              message: "Server is Down! Please try again after sometime",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 400) {
          dispatch(
            getNotification({
              message: "Input is not in prescribed format",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 422) {
          dispatch(
            getNotification({
              message: "Input is not in prescribed format",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 404) {
          dispatch(
            getNotification({
              message: "Page not Found",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 401) {
          dispatch(
            getNotification({
              message: "Session expired! Please log in again",
              type: "default",
            })
          );
        } else {
          dispatch(
            getNotification({
              message: "Server is Down! Please try again after sometime",
              type: "default",
            })
          );
        }
      }
    } else {
      setTimeout(() => {
        UserService.doLogin({
          redirectUri: `${REACT_APP_REDIRECT_URI}/modelperformance`,
        });
      }, 1000);
    }
    setloader(false)
  };
  const handlemodelperformanceapicharts = async (marketrow, brandrow) => {
    setloader2(true)
    if (UserService.isLoggedIn()) {
      try {
        if (selectedbrand && selectedbrand !== "Select" && market !== "Select" && market

        ) {
          try {
            let config1 = {};

            const requestData2 = {

              "scenario_name": 'Base Scenario',
              "scenario_timestamp": '2024-12-12 18:20:35',
              "user_id": "admin",
              "market": marketrow,
              "model_id": 0,
              "brand": selectedbrand
            }

            const config2 = {
              method: "post",
              url: selectedbrand === "ATTA" ? `${REACT_APP_UPLOAD_DATA}/app/atta_model_performance_plots` : `${REACT_APP_UPLOAD_DATA}/api/model_performance_plots`,
              headers: {
                Accept: "text/plain",
                "Content-Type": "application/json",

              },
              data: requestData2,
            };

            const getResponse2 = await axios(config2);

            if (getResponse2?.data?.data) {

              getResponse2?.data?.data?.export_contribution && setexportcontributiondata(getResponse2?.data?.data?.export_contribution)
              // settorangeonplots(getResponse2?.data?.data?.plot1[getResponse2?.data?.data?.plot1.length-1]?.month_year?.split("-").reverse()?.join("-"))
              setselectedmarketdataset(getResponse2.data.data)
              // setlastfymapedata(getResponse?.data?.data?.fy_mape_data?.sort((a,b)=>a.market?.localeCompare(b.market)))
            }
          } catch (err) {
            console.log("Server Error", err);
            if (displaynames) {
              setselectedbrand(displaynames.brand || brandoptions[0].brand)
              setselectedscenarioname(displaynames.scenarioname || modelcallibrationoptions[1]?.scenario_name)
              setselectedzone(displaynames.zone || 'National')
              setselectedyear(displaynames.year || '2021-22')
              // setselectedscenarioid(displaynames.id || modelcallibrationoptions[1].id)
            }
            if (err.response && err.response.status === 500) {
              dispatch(
                getNotification({
                  message: "Server is Down! Please try again after sometime",
                  type: "default",
                })
              );
            } else if (err.response && err.response.status === 400) {
              dispatch(
                getNotification({
                  message: "Input is not in prescribed format",
                  type: "default",
                })
              );
            } else if (err.response && err.response.status === 422) {
              dispatch(
                getNotification({
                  message: "Input is not in prescribed format",
                  type: "default",
                })
              );
            } else if (err.response && err.response.status === 404) {
              dispatch(
                getNotification({
                  message: "Page not Found",
                  type: "default",
                })
              );
            } else if (err.response && err.response.status === 401) {
              dispatch(
                getNotification({
                  message: "Session expired! Please log in again",
                  type: "default",
                })
              ); setTimeout(UserService.doLogin(), 1000)
            } else {
              dispatch(
                getNotification({
                  message: "Server is Down! Please try again after sometime",
                  type: "default",
                })
              );
            }
          }
        }
        else {
          dispatch(
            getNotification({
              message: "Please fill all entries",
              type: "danger",
            })
          );
        }
      }
      catch (err) {
        console.log("Server Error", err);
        if (err.response && err.response.status === 500) {
          dispatch(
            getNotification({
              message: "Server is Down! Please try again after sometime",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 400) {
          dispatch(
            getNotification({
              message: "Input is not in prescribed format",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 422) {
          dispatch(
            getNotification({
              message: "Input is not in prescribed format",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 404) {
          dispatch(
            getNotification({
              message: "Page not Found",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 401) {
          dispatch(
            getNotification({
              message: "Session expired! Please log in again",
              type: "default",
            })
          );
        } else {
          dispatch(
            getNotification({
              message: "Server is Down! Please try again after sometime",
              type: "default",
            })
          );
        }
      }
    } else {
      setTimeout(() => {
        UserService.doLogin({
          redirectUri: `${REACT_APP_REDIRECT_URI}/modelperformance`,
        });
      }, 1000);
    }
    setloader2(false)
  };
  const formatDate = (dateString) => {
    const [month, year] = dateString.split("-");
    const date = new Date(`${year}-${month}-01`);
    return date.toLocaleString('default', { month: 'short', year: 'numeric' });
  };
  function formatDate2() {
    // Create a Date object using the specified date string
    const date = new Date();

    // Extract year, month, and day
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is zero-based
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    // Return the date in "YYYY-MM-DD" format
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  }
  const handlevariablesfetch = async () => {
    if (UserService.isLoggedIn()) {
      try {
        setisprocessing(true)
        const FormData = require("form-data");
        const sendData = new FormData();
        const config = {
          method: "get",
          url: selectedbrand === "ATTA" ? `${REACT_APP_UPLOAD_DATA}/app/atta_get_date` : `${REACT_APP_UPLOAD_DATA}/app/fetchvars`,
          headers: {
            Accept: "text/plain",
            "Content-Type": "application/json",
            // "req-header":UserService.getToken()
          },
          data: sendData,
        };
        const getResponse = selectedbrand ? await axios(config) : [];
        if (getResponse.status === 200) {

          selectedbrand === "ATTA" ? setStartDate(getResponse.data.start_date?.split("T")[0]) : setStartDate(getResponse.data.dates[0].min[0].start_date);
          selectedbrand === "ATTA" ? setEndDate(getResponse.data.end_date?.split("T")[0]) : setEndDate(getResponse.data.dates[0].max[0].end_date);

        }
      } catch (err) {
        console.log("Server Error", err);
        if (err.response && err.response.status === 500) {
          dispatch(
            getNotification({
              message: "Server is Down! Please try again after sometime",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 400) {
          dispatch(
            getNotification({
              message: "Input is not in prescribed format",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 422) {
          dispatch(
            getNotification({
              message: "Input is not in prescribed format",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 404) {
          dispatch(
            getNotification({
              message: "Page not Found",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 401) {
          dispatch(
            getNotification({
              message: "Session expired! Please log in again",
              type: "default",
            })
          );
        } else {
          dispatch(
            getNotification({
              message: "Server is Down! Please try again after sometime",
              type: "default",
            })
          );
        }
      }
    } else {
      setTimeout(() => {
        UserService.doLogin({
          redirectUri: `${REACT_APP_REDIRECT_URI}/brandanalysis`,
        });
      }, 1000);
    }
    setisprocessing(false)
  };


  const downloadMapeResults = () => {
    const data = [];
    console.log(mapetable)
    const headers = [];

    headers.push("Brand")
    headers.push("Market")
    headers.push("Last FY")
    headers.push("Last FY MAPE")
    headers.push("Current FY")
    headers.push("Current FY MAPE")



    data.push(headers);
    mapetable?.map((row) => {
      const brand = row.brand;
      const market = row.market;
      const lastfy = row.lastfy;
      const lastmape = `${(row.lastmape * 100).toFixed(1)}%`;
      const currentfy = row.currentfy;
      const currentmape = `${(row.currentmape * 100).toFixed(1)}%`;
      data.push([brand, market, lastfy, lastmape, currentfy, currentmape]);
    })

    //   !ExceptionVariables.hiddenvariables.some((it) => it === varItem.attribute_name)
    // )
    //   ?.forEach((item) => {
    //   // Extract the attribute name
    //   const scenario_name = displaynames2.scenario;
    //   const brand_name = item.brand;
    //   const final_market_name = item.final_market;
    //   const fy = item.fy;
    //   const attributeName = item.attribute_name;
    //   // Process month_data and extract values
    //   const monthDataValues = item.month_data.map((month) => {
    //     const value = month.attribute_value;
    //     return Array.isArray(value) && value.length === 0 ? "No matched category" : value;
    //   });

    //   // Calculate subtotal (e.g., summing numeric values)
    //   const subtotal = monthDataValues.reduce((sum, val) => {
    //     return typeof val === "number" ? sum + val : sum;
    //   }, 0);

    //   // Push the row data
    //   data.push([scenario_name, brand_name, final_market_name, fy, attributeName, ...monthDataValues, subtotal]);
    // });

    // Create a new workbook
    const workbook = XLSX.utils.book_new();

    // Create a new worksheet and add data to it
    const worksheet = XLSX.utils.aoa_to_sheet(data);
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Convert the workbook to a binary Excel file
    const excelBuffer = XLSX.write(workbook, { type: "array" });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    // Create a URL from the Blob
    const url = URL.createObjectURL(blob);

    // Create a download link and trigger the download
    const link = document.createElement("a");
    link.href = url;
    link.download = `${selectedbrand}-MapeResults.xlsx`;
    link.click();


  }
  const downloadLineChartResults = () => {
    const data = [];

    const headers = [];

    //  headers.push("Brand")
    //  headers.push("Market")
    //  headers.push("Variable")


    //  data.push(headers);
    const monthHeaders = Object.keys(exportcontributiondata[0])?.map((it) => { return it })

    data.push(monthHeaders)
    exportcontributiondata?.forEach((row) => {
      const rowData = monthHeaders.map((header) => row[header]); // keep order same as headers
      data.push(rowData);
    });

    //   !ExceptionVariables.hiddenvariables.some((it) => it === varItem.attribute_name)
    // )
    //   ?.forEach((item) => {
    //   // Extract the attribute name
    //   const scenario_name = displaynames2.scenario;
    //   const brand_name = item.brand;
    //   const final_market_name = item.final_market;
    //   const fy = item.fy;
    //   const attributeName = item.attribute_name;
    //   // Process month_data and extract values
    //   const monthDataValues = item.month_data.map((month) => {
    //     const value = month.attribute_value;
    //     return Array.isArray(value) && value.length === 0 ? "No matched category" : value;
    //   });

    //   // Calculate subtotal (e.g., summing numeric values)
    //   const subtotal = monthDataValues.reduce((sum, val) => {
    //     return typeof val === "number" ? sum + val : sum;
    //   }, 0);

    //   // Push the row data
    //   data.push([scenario_name, brand_name, final_market_name, fy, attributeName, ...monthDataValues, subtotal]);
    // });

    // Create a new workbook
    const workbook = XLSX.utils.book_new();

    // Create a new worksheet and add data to it
    const worksheet = XLSX.utils.aoa_to_sheet(data);
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Convert the workbook to a binary Excel file
    const excelBuffer = XLSX.write(workbook, { type: "array" });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    // Create a URL from the Blob
    const url = URL.createObjectURL(blob);

    // Create a download link and trigger the download
    const link = document.createElement("a");
    link.href = url;
    link.download = `${selectedbrand}-ContributionResults.xlsx`;
    link.click();


  }
  return (
    <>
      <Navbar3 />
      <div className="bgpages" style={{userSelect:'none'}}>
        <div className='container-fluid'>
          <div className='breadcrumb '>{`Dashboard >> Model Performance`}</div>
          <div className='pageheading d-flex justify-content-between align-items-center my-2 px-3 py-2' style={{ fontSize: "20px" }}>
            <b>
              Model Performance{" "}
              {endDate && !isprocessing && (
                <span style={{ fontSize: "16px", color: "#070707ff" }}>
                  (Data updated till <strong>{endDate}</strong>)
                </span>
              )}
            </b>
            {resultscreen && <div><button className="btn btn-orange   my-auto mx-2" onClick={() => { setselectedscenarioname(""); setresultscreen(false); setmarket(""); setselectedbrand(""); setmodifybtn(false); setopenindex([]); setexportcontributiondata([]) }}>Reset</button>
              <button className="btn btn-info fw-semibold" style={{ color: 'black' }} onClick={() => setmodifybtn(!modifybtn)}>
                {modifybtn ? 'Close' : 'Modify'}
              </button>
            </div>
            }
          </div>

          {
            modifybtn &&
            <>
              <div className="card p-3">
                <div className="d-flex justify-content-between my-2 "  >
                  <div className="">
                    <div className="">Brand:<span className="text-danger">*</span></div>

                    <Select
                      placeholder="Select Brand"
                      value={maskedBrandOption.maskedBrandOption[selectedbrand] ? { label: maskedBrandOption.maskedBrandOption[selectedbrand], value: selectedbrand } : null}
                      className=" my-2 "
                      options={brandoptions}
                      onChange={(value) => {
                        setselectedbrand(value.value)
                        setmarket([])
                        setresultscreen(false)
                        setmodifybtn(false)
                      }}
                    />
                  </div>
                  <div className="mx-2">
                    <div className="">Market:<span className="text-danger">*</span></div>

                    <Select className=" my-2"
                      placeholder="Select market"
                      options={marketoptions}
                      isMulti
                      value={market ? market.map((it) => { return { label: it, value: it } }) : null}
                      onChange={(value) => {
                        if (value.some(item => item.value === 'selectAll')) {
                          setmarket(marketoptions.filter((it) => it.value !== "selectAll").map((option) => option.value));
                        }
                        else {
                          setmarket(value.map((it) => it.value));
                        }

                      }}
                    >
                    </Select>

                  </div>
                  <div>
                    <button
                      id="subm"
                      className="btn btn-dark mt-4"
                      onClick={() => {
                        handlemodelperformanceapi()
                      }}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </>
          }


          {resultscreen ?
            loader ? (
              <div
                className="row d-flex  justify-content-center align-items-center "
                style={{ height: "75vh" }}
              >
                <Loader
                  type="box-rectangular"
                  bgColor={"black"}
                  title={"Processing Plots..."}
                  color={"black"}
                  size={75}
                />
              </div>)
              :
              <div className=" ">
                {mapetable?.length > 0 && (
                  <div className="accordion my-3" id="comparisonAccordion">
                    <div className="accordion-item shadow-sm border-0">
                      <h2 className="accordion-header" id="headingOne">
                        <button
                          className="accordion-button d-flex justify-content-between align-items-center fw-bold"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseOne"
                          aria-expanded="true"
                          aria-controls="collapseOne"
                        >
                          Market Wise Mape Table Details
                        </button>
                      </h2>
                      <div
                        id="collapseOne"
                        className="accordion-collapse collapse show"
                        aria-labelledby="headingOne"
                        data-bs-parent="#comparisonAccordion"
                      >
                        <div className="accordion-body">
                          <button className="btn btn-sm btn-secondary mb-4" onClick={downloadMapeResults}>
                            Download Mape Comparision <i className="mx-1 fa fa-download"></i>
                          </button>

                          <div className="table-responsive ">
                            <table
                              className="text-center table table-sm table-striped shadow table-bordered table-hover"
                              style={{ fontSize: "10px", height: "auto" }}
                            >
                              <thead className="table-dark">
                                <tr>
                                  <th>S. No.</th>
                                  <th>Brand</th>
                                  <th>Market</th>
                                  <th>Last FY</th>
                                  <th>Last FY MAPE</th>
                                  <th>Current Year</th>
                                  <th>Current MAPE</th>
                                  <th>Select for More Details</th>
                                </tr>
                              </thead>
                              <tbody>
                                {mapetable.map((row, index) => (
                                  <React.Fragment key={index}>
                                    <tr>
                                      <td>{index + 1}</td>
                                      <td>{maskedBrandOption.maskedBrandOption[row?.brand]}</td>
                                      <td>{row?.market}</td>
                                      <td>{row?.lastfy}</td>
                                      <td
                                        style={{
                                          color: "white",
                                          backgroundColor:
                                            row?.lastmape <= 0.1
                                              ? "green"
                                              : row?.lastmape <= 0.15
                                                ? "orange"
                                                : "red",
                                        }}
                                      >
                                        {(row?.lastmape * 100)?.toFixed(1)}%
                                      </td>
                                      <td>{row?.currentfy}</td>
                                      <td
                                        style={{
                                          color: "white",
                                          backgroundColor:
                                            row?.currentmape <= 0.1
                                              ? "green"
                                              : row?.currentmape <= 0.15
                                                ? "orange"
                                                : "red",
                                        }}
                                      >
                                        {(row?.currentmape * 100)?.toFixed(1)}%
                                      </td>
                                      <td>
                                        <button
                                          className="btn btn-sm btn-outline-primary"
                                          onClick={() => {
                                            setexportcontributiondata([]);
                                            handleCheckboxChange(index, row);
                                          }}
                                        >
                                          {openindex[index] ? "Hide" : "More Details"}
                                        </button>
                                      </td>
                                    </tr>

                                    {openindex[index] && (
                                      <tr>
                                        <td colSpan="8">
                                          {loader2 ? (
                                            <div className="d-flex justify-content-center align-items-center py-4">
                                              <div className="dot-flashing"></div>
                                            </div>
                                          ) : (
                                            <>
                                              {
                                                exportcontributiondata?.length > 0 && (
                                                  <div className="d-flex justify-content-end align-items-end">

                                                    <button className="btn btn-sm btn-secondary mb-4" onClick={downloadLineChartResults}>
                                                      Download Contribution
                                                    </button>

                                                  </div>
                                                )}

                                              <ModelPerformanceChart
                                                data={mapetable[index]}
                                              />

                                              {/* --- Your chart sections remain here --- */}
                                              <div className="container-fluid my-3">
                                                <div className="row g-3">
                                                  {/* Pie Chart */}
                                                  {selectedmarketdataset?.plot2?.length > 0 && (
                                                    <div className="col-lg-6 col-md-12">
                                                      <div className="card p-3 shadow-sm rounded h-100">
                                                        <PieCharts
                                                          isValue={isValue}
                                                          range={`${formatDate(fromrangeonplots)}-${formatDate(torangeonplots)}`}
                                                          fulldataset={selectedmarketdataset}
                                                          type={row.market}
                                                          displaynames={displaynames}
                                                        />
                                                      </div>
                                                    </div>
                                                  )}

                                                  {/* SingleBarChart1 */}
                                                  {selectedmarketdataset?.plot3?.length > 0 && (
                                                    <div className="col-lg-6 col-md-12">
                                                      <div className="card p-3 shadow-sm rounded h-100">
                                                        <SingleBarChart1
                                                          fulldataset={selectedmarketdataset}
                                                          maxValuedynamicVolume={Math.ceil(
                                                            Math.max(
                                                              ...[
                                                                selectedmarketdataset?.plot3[0].total_core / 1000 ?? 0,
                                                                selectedmarketdataset?.plot3[1].total_incremental / 1000 ?? 0,
                                                                selectedmarketdataset?.plot3[2].total_media / 1000 ?? 0,
                                                              ]
                                                            ) / 100
                                                          ) * 100}
                                                          maxValuedynamicValue={Math.ceil(
                                                            Math.max(
                                                              ...[
                                                                selectedmarketdataset?.plot3[0].total_core_sales / 1000 ?? 0,
                                                                selectedmarketdataset?.plot3[1].total_incremental_sales / 1000 ?? 0,
                                                                selectedmarketdataset?.plot3[2].total_media_sales / 1000 ?? 0,
                                                              ]
                                                            ) / 100
                                                          ) * 100}
                                                          type={row.market}
                                                          isValue={isValue}
                                                          range={`${formatDate(fromrangeonplots)}-${formatDate(torangeonplots)}`}
                                                        />
                                                      </div>
                                                    </div>
                                                  )}

                                                  {/* SingleBarChart2 */}
                                                  {selectedmarketdataset?.plot4?.length > 0 && (
                                                    <div className="col-lg-6 col-md-12">
                                                      <div className="card p-3 shadow-sm rounded h-100">
                                                        <SingleBarChart2
                                                          fulldataset={selectedmarketdataset}
                                                          type={row.market}
                                                          isValue={isValue}
                                                          range={`${formatDate(fromrangeonplots)}-${formatDate(torangeonplots)}`}
                                                          maxValuedynamicVolume={Math.ceil(
                                                            Math.max(...selectedmarketdataset?.plot4.map((it) => it.contribution)) / 100
                                                          ) * 100}
                                                          maxValuedynamicValue={Math.ceil(
                                                            Math.max(...selectedmarketdataset?.plot4.map((it) => it.contribution_sales_value / 100000)) / 100
                                                          ) * 100}
                                                        />
                                                      </div>
                                                    </div>
                                                  )}

                                                  {/* SingleBarChart5 */}
                                                  {selectedmarketdataset?.plot10?.length > 0 && (
                                                    <div className="col-lg-6 col-md-12">
                                                      <div className="card p-3 shadow-sm rounded h-100">
                                                        <SingleBarChart5
                                                          fulldataset={selectedmarketdataset}
                                                          type={row.market}
                                                          isValue={isValue}
                                                          range={`${formatDate(fromrangeonplots)}-${formatDate(torangeonplots)}`}
                                                          maxValuedynamicVolume={Math.ceil(
                                                            Math.max(...selectedmarketdataset?.plot10.map((it) => it.contribution)) / 100
                                                          ) * 100}
                                                          maxValuedynamicValue={Math.ceil(
                                                            Math.max(...selectedmarketdataset?.plot10.map((it) => it.contribution_sales_value / 100000)) / 100
                                                          ) * 100}
                                                        />
                                                      </div>
                                                    </div>
                                                  )}

                                                  {/* SingleBarChart4 */}
                                                  {selectedmarketdataset?.plot5?.length > 0 && (
                                                    <div className="col-lg-6 col-md-12">
                                                      <div className="card p-3 shadow-sm rounded h-100">
                                                        <SingleBarChart4
                                                          fulldataset={selectedmarketdataset}
                                                          type={row.market}
                                                          isValue={isValue}
                                                          range={`${formatDate(fromrangeonplots)}-${formatDate(torangeonplots)}`}
                                                          maxValuedynamicVolume={Math.ceil(
                                                            Math.max(...selectedmarketdataset?.plot5?.map((it) => Number(it?.attribute_value_per_roi)))
                                                          )}
                                                        />
                                                      </div>
                                                    </div>
                                                  )}

                                                  {/* SingleBarChart8 */}
                                                  {selectedmarketdataset?.plot13?.length > 0 && (
                                                    <div className="col-lg-6 col-md-12">
                                                      <div className="card p-3 shadow-sm rounded h-100">
                                                        <SingleBarChart8
                                                          fulldataset={selectedmarketdataset}
                                                          type={row.market}
                                                          isValue={isValue}
                                                          range={`${formatDate(fromrangeonplots)}-${formatDate(torangeonplots)}`}
                                                          maxValuedynamicVolume={
                                                            (Math.ceil(
                                                              Math.max(...selectedmarketdataset?.plot13?.map((it) => Number(it?.attribute_value_per_roi)))
                                                            ) / 10) * 10
                                                          }
                                                        />
                                                      </div>
                                                    </div>
                                                  )}

                                                  {/* SingleBarChart7 */}
                                                  {selectedmarketdataset?.plot12?.length > 0 && (
                                                    <div className="col-lg-6 col-md-12">
                                                      <div className="card p-3 shadow-sm rounded h-100">
                                                        <SingleBarChart7
                                                          fulldataset={selectedmarketdataset}
                                                          type={row.market}
                                                          isValue={isValue}
                                                          range={`${formatDate(fromrangeonplots)}-${formatDate(torangeonplots)}`}
                                                          maxValuedynamicVolume={Math.ceil(
                                                            Math.max(...selectedmarketdataset?.plot12?.map((it) => Number(it?.attribute_value_per_roi)))
                                                          )}
                                                        />
                                                      </div>
                                                    </div>
                                                  )}

                                                  {/* SingleBarChart6 */}
                                                  {
                                                    selectedmarketdataset?.plot11?.length > 0 &&
                                                    <div className="col-lg-6 col-md-12">
                                                      <div className="card p-3 shadow-sm rounded h-100" >
                                                        <SingleBarChart6 fulldataset={selectedmarketdataset} type={row.market} isValue={isValue} range={`${formatDate(fromrangeonplots)}-${formatDate(torangeonplots)}`}
                                                          maxValuedynamicVolume={
                                                            Math.ceil(Math.max(...selectedmarketdataset?.plot11?.map((it) => { return Number(it?.effectiveness) })) / 10) * 10
                                                          }
                                                        />

                                                      </div>
                                                    </div>
                                                  }

                                                  {/* SingleBarChart3 */}
                                                  {selectedmarketdataset?.plot9?.length > 0 && (
                                                    <div className="col-lg-12 col-md-12">
                                                      <div className="card p-3 shadow-sm rounded h-100">
                                                        <SingleBarChart3
                                                          fulldataset={selectedmarketdataset}
                                                          type={row.market}
                                                          isValue={isValue}
                                                          range={`${formatDate(fromrangeonplots)}-${formatDate(torangeonplots)}`}
                                                          maxValuedynamicVolume={
                                                            Math.ceil(
                                                              Math.max(...selectedmarketdataset?.plot9?.map((it) => Number(it?.effectiveness))) / 10
                                                            ) * 10
                                                          }
                                                        />
                                                      </div>
                                                    </div>
                                                  )}
                                                </div>
                                              </div>

                                            </>
                                          )}
                                        </td>
                                      </tr>
                                    )}
                                  </React.Fragment>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {mapetable?.length === 0 && (
                  <div className="alert alert-warning text-center shadow-sm my-3">
                    There are no records to display!!
                  </div>
                )}
              </div> :
            loader ? (
              <div
                className="row d-flex  justify-content-center align-items-center "
                style={{ height: "75vh" }}
              >
                <Loader
                  type="box-rectangular"
                  bgColor={"black"}
                  title={"Processing Plots..."}
                  color={"black"}
                  size={75}
                />
              </div>) :
              <>
                <div className="card p-3">
                  <div className="row ">
                    <div className="col-sm">
                      <div className="">Brand<span className="text-danger">*</span></div>
                      <div className="">
                        <Select
                          placeholder="Select Brand"
                          value={maskedBrandOption.maskedBrandOption[selectedbrand] ? { label: maskedBrandOption.maskedBrandOption[selectedbrand], value: selectedbrand } : null}
                          className=" my-2 w-75"
                          options={brandoptions}
                          onChange={(value) => {
                            setselectedbrand(value.value)
                            setmarket([])
                            setresultscreen(false)
                            setmodifybtn(false)
                          }}
                        />

                      </div>
                    </div>
                    <div className="col-sm">
                      <div className="">Market<span className="text-danger">*</span></div>
                      <div className="">
                        <Select className=" my-2 w-75"
                          placeholder="Select market"
                          options={marketoptions}
                          isMulti
                          value={market ? market.map((it) => { return { label: it, value: it } }) : null}
                          onChange={(value) => {
                            if (value.some(item => item.value === 'selectAll')) {

                              setmarket(marketoptions.filter((it) => it.value !== "selectAll").map((option) => option.value));
                            }
                            else {
                              setmarket(value.map((it) => it.value));
                            }

                          }}
                        >
                        </Select>
                      </div>
                    </div>
                  </div>

                  <div class="submitfrmtbtn mb-2" type="button" onClick={() => {
                    // fetchdatasettable()
                    handlemodelperformanceapi()
                  }}><span>Submit <iconify-icon icon="iconamoon:arrow-right-2-bold"></iconify-icon></span>
                  </div>

                </div></>}

          <div></div>
        </div>
      </div>
      <div className='' >
        <FooterPages />
      </div>

      <style>
        {`
          .dot-flashing {
            position: relative;
            width: 12px;
            height: 12px;
            border-radius: 6px;
            background-color: #007bff;
            color: #007bff;
            animation: dotFlashing 1s infinite linear alternate;
            animation-delay: 0.5s;
          }
          .dot-flashing::before,
          .dot-flashing::after {
            content: "";
            display: inline-block;
            position: absolute;
            top: 0;
          }
          .dot-flashing::before {
            left: -18px;
            width: 12px;
            height: 12px;
            border-radius: 6px;
            background-color: #007bff;
            color: #007bff;
            animation: dotFlashing 1s infinite alternate;
            animation-delay: 0s;
          }
          .dot-flashing::after {
            left: 18px;
            width: 12px;
            height: 12px;
            border-radius: 6px;
            background-color: #007bff;
            color: #007bff;
            animation: dotFlashing 1s infinite alternate;
            animation-delay: 1s;
          }
          @keyframes dotFlashing {
            0% { background-color: #007bff; }
            50%, 100% { background-color: #cce5ff; }
          }
          `}
      </style>
    </>

  )
}

export default ModelPerformance